import { useEffect, useState } from 'react';
import { ProjectAPI } from '@brg/api';
import { useProfile } from "@brg/auth";
export var useGetPresentations = function () {
    var _a = useState(null), projects = _a[0], setProjects = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var profile = useProfile();
    useEffect(function () {
        if (!profile || !(profile === null || profile === void 0 ? void 0 : profile.accountId))
            return;
        setLoading(true);
        ProjectAPI.GetList({
            projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small'],
            isLite: true,
            isContextIgnored: true,
            appNameIgnore: true,
            projectFilter: 2,
            projectStatus: [1, 7, 9],
            authorIds: [profile === null || profile === void 0 ? void 0 : profile.accountId],
            contextsNotContains: ['lmsproject', 'lmshseproject']
        })
            .then(function (r) { return r.json(); })
            .then(function (r) {
            setProjects((r === null || r === void 0 ? void 0 : r.data) || null);
            setLoading(false);
        })
            .catch(function (error) {
            console.error(error);
            setError(true);
            setLoading(false);
        });
    }, [profile]);
    return {
        projects: projects,
        loading: loading,
        error: error
    };
};
//# sourceMappingURL=useGetPresentations.js.mapimport { useEffect, useState } from 'react';
import { ProjectAPI } from '@brg/api';
import { useProfile } from "@brg/auth";
export var useGetPresentations = function () {
    var _a = useState(null), projects = _a[0], setProjects = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var profile = useProfile();
    useEffect(function () {
        if (!profile || !(profile === null || profile === void 0 ? void 0 : profile.accountId))
            return;
        setLoading(true);
        ProjectAPI.GetList({
            projectTypes: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small'],
            isLite: true,
            isContextIgnored: true,
            appNameIgnore: true,
            projectFilter: 2,
            projectStatus: [1, 7, 9],
            authorIds: [profile === null || profile === void 0 ? void 0 : profile.accountId],
            contextsNotContains: ['lmsproject', 'lmshseproject']
        })
            .then(function (r) { return r.json(); })
            .then(function (r) {
            setProjects((r === null || r === void 0 ? void 0 : r.data) || null);
            setLoading(false);
        })
            .catch(function (error) {
            console.error(error);
            setError(true);
            setLoading(false);
        });
    }, [profile]);
    return {
        projects: projects,
        loading: loading,
        error: error
    };
};
//# sourceMappingURL=useGetPresentations.js.map